interface PixelArgs {
  metaPixelId: string;
}
let facebookEnabled = false;
export function initMetaContainer(args: PixelArgs): void {
  const {
    metaPixelId
  } = args;
  if (metaPixelId && !facebookEnabled) {
    facebookEnabled = true;

    //loads Facebook Pixel Code
    const fbq = function (f: any, b, e, v, n?: any, t?, s?) {
      if (f['fbq']) return f['fbq'];
      n = f.fbq = function () {
        // eslint-disable-next-line prefer-rest-params, prefer-spread
        n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments);
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = !0;
      n.version = '2.0';
      n.queue = [];
      t = b.createElement(e);
      t.async = !0;
      t.src = v;
      s = b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t, s);
      return n;
    }(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
    fbq?.('init', metaPixelId);
  }
}
export function facebookTrack(eventtName: string, data: any): void {
  if (facebookEnabled) {
    window?.['fbq']?.('track', eventtName, data);
  }
}